import { convertPhToISODate } from '~shared/lib/convert-date';

import { formatOptionalField } from './format-optional-field';

import { type BasicInfoFormValues, PersonDataRequest } from '../../model';

export function formatBasicInfo(
  values: BasicInfoFormValues
): PersonDataRequest {
  return {
    firstName: values.firstName,
    middleName: values.middleName,
    lastName: values.lastName,
    email: values.email,
    birthDate: convertPhToISODate(values.dateOfBirth),
    pointOfContact: formatOptionalField(values.pointOfContact),
  };
}
